var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "262px",
    height: "264px",
    viewBox: "0 0 262 264",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pencil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,33.4589388 C1.12618179,33.5868988 11.3489095,44.3495372 11.4770941,44.4744982 L11.4680812,44.4824957 L49.5339219,82.9624769 C60.1482137,93.6931253 76.5818893,95.0636972 86.2378004,86.0235208 C95.8937115,76.9823447 95.1155905,60.9543509 84.5002972,50.2227028 L46.435458,11.7427216 L46.426445,11.7517188 C46.3032675,11.6217594 33.9875245,-0.344503107 35.7470594,1.1250379 L1,33.4589388",
    id: "Fill-12",
    fill: "#FF9B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1177324,16 C7.03468855,25.2489385 1.30861456,33.5845006 11.3608106,43.7578322 C11.4870768,43.8850239 11.6183536,44.0062065 11.7466241,44.1313952 L11.7376051,44.1394073 L49.8289243,82.6895039 C51.4713876,84.3520094 53.2541468,85.7891752 55.1291003,87 L75,72.6714062 L15.1177324,16",
    id: "Fill-13",
    fill: "#F2933A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.754805,240.782737 L254.390925,259.716543 C257.869575,261.04446 261.197417,257.458686 259.578739,254.115896 L234.695329,202.500149 C218.578922,193.139739 193.66535,230.223402 204.754805,240.782737",
    id: "Fill-111",
    fill: "#E6D0BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.082061,263.725159 L236,253.169856 C245.292496,253.405785 251.33559,249.652094 251.771485,239 L261.717824,259.991633 C262.837282,262.354956 260.420045,264.840277 258.082061,263.725159",
    id: "Fill-112",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,29 L234.708257,201.504456 C238.441396,211.687669 234.378862,219.569998 218.637793,224 L64.7955379,64.1943523 C84.1090418,54.8480058 73.4027188,42.0093873 64,29",
    id: "Fill-113",
    fill: "#30A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,224.315129 C218.729587,228.260783 220.241897,237.581342 204.928502,240 L39,72.9480473 C55.6043678,69.1131034 62.1994436,60 62.1994436,60 L219,224.315129",
    id: "Fill-114",
    fill: "#1C7EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.017563,62.5879749 C28.9172466,62.4401029 29.2738168,62.837446 29.4009505,62.9631875 L29.3920114,62.9712349 L47.4042703,81.233926 C55.792113,91.0246599 91.1094498,57.3601475 82.7216072,47.5704196 C82.7216072,47.5704196 63.6654616,28.8490236 63.7618051,29.0009193 C70.9279726,40.3387762 37.1570977,74.4801002 29.017563,62.5879749",
    id: "Fill-115",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6621412,53 C45.5528471,61.3966718 35.1711294,67.6105695 30,64.08609 L47.2647529,81.1898282 C51.6972941,86.2452534 64.4303529,80.0854245 73,70.4601912 L53.6621412,53",
    id: "Fill-168",
    fill: "#FFE6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1775927,1.01667429 C38.1395085,4.20836485 32.8485988,13.9505824 23.3607308,22.7774773 C13.8738564,31.6043721 3.78287432,36.1740214 0.821952063,32.9833257 C-2.1389702,29.7926301 3.15193955,20.0494176 12.638814,11.2225227 C22.126682,2.39562788 32.217664,-2.17402135 35.1775927,1.01667429",
    id: "Fill-169",
    fill: "#FFB36B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.1791d9ba9108f8439c4fcf359a84ccd9.svg";
export { ForwardRef as ReactComponent };